import { Col, Form, Input, Radio, Row } from "antd";
import styles from "./index.module.less";
import CitySelector from "./components/CitySelector";
import InputBox from "./components/InputBox";
import { useEffect, useState } from "react";
import modalCloseIcon from "@/assets/imgs/modal_close.svg";
import classNames from "classnames";
import message from "@/plugins/message";
import SMSCodeBtn from "./components/SMSCodeBtn";
import { useWatch } from "antd/es/form/Form";
import { isMobile, uuid4V1 } from "@/utils";
import MobileContactModal from "./mobile";
import ContactMain from "./components/Main";

const validateFn = (key: string, value: any) => {
  if (key === "company" || key === "phone" || key === "name") {
    return value ? "" : `请输入您的${key}`;
  }
  if (key === "email") {
    return value && !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)
      ? "请输入正确的邮箱地址"
      : "";
  }
  return "";
};
const FormLabel = ({
  label,
  required,
}: {
  label: string;
  required?: boolean;
}) => {
  return (
    <div className={styles.label}>
      {label}
      {required && <span>*</span>}
    </div>
  );
};
const ContactModal = ({
  visible,
  title,
  onClose,
}: {
  visible: boolean;
  title?: string;
  onClose?: () => void;
}) => {
  if (!visible) {
    return null;
  }
  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };
  const [closing, setClosing] = useState(false);
  return (
    <div className={styles.contactModal}>
      <div
        className={classNames(styles.mask, {
          [styles.fadeOut]: closing,
          [styles.fadeIn]: !closing,
        })}
      ></div>
      <ContactMain onClose={handleClose} />
    </div>
  );
};

export default isMobile() ? MobileContactModal : ContactModal;
